// extracted by mini-css-extract-plugin
export default {"btn":"ActionBtn_btn__G9IaN","actionBtn":"ActionBtn_actionBtn__xDulc","cancelBtn":"ActionBtn_cancelBtn__MawxI"};